import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { alertSelectors, authSelectors } from '../../../common/redux/selectors';
import { defaultService, globalService as gs } from '../../../common/services';

class ProfileVerified extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    sendVerify = () => {
        const { dispatch } = this.props;
        confirmAlert({
            //title: `Please confirm to resubmit verification`,
            message: `Please confirm to resubmit verification`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => console.log('No')
                },
                {
                    label: 'Yes',
                    onClick: () => {
                        this.setState({loading: true});
                        defaultService.resubmitVerification("POST").then(data => {
                            this.setState({loading: false});
                            //console.log('data', data);
                            dispatch(authSelectors.success(data));
                            dispatch(alertSelectors.success('You have to submit resubmit verification.'))
                        })
                        .catch(exception => {
                            gs.showErrors(dispatch, exception, alertSelectors);
                            this.setState({loading: false});
                        });
                    }
                }
            ]
        });
    }

    resendButton = () => {
        const { loading } = this.state;
        return <button className="btn btn-primary btn-sm" style={{padding: '4px 8px', fontSize: '10px'}} onClick={this.sendVerify}>Resend {loading && <>&nbsp; <div className="spinner-border spinner-border-sm text-white" role="status"></div> </>}</button>
    }

    render() {
        const { user } = this.props.authentication.authentication;
        //console.log(user, user.is_verified);
        return (
            <div className="verify">
                {user.is_verified === 0 && <div className="text-dark inner"><img src="/images/svg/verified-pending.svg" alt="Unverified" /> Unverified</div>}
                {user.is_verified === 1 && <div className="text-dark inner"><img src="/images/svg/verified-pending.svg" alt="Pending" /> Pending {this.resendButton()}</div>}
                {user.is_verified === 2 && <div className="text-dark inner"><img src="/images/svg/Verified.svg" alt="Verified" /> Verified</div>}
                {user.is_verified === 3 && <div className="text-dark inner"><img src="/images/svg/verified-submit.svg" alt="Submit for Approval" /> Profile not completed {this.resendButton()}</div>}
                {user.is_verified === 4 && <div className="text-dark inner"><img src="/images/svg/verified-submit.svg" alt="Submit for Approval" /> Submit to verification</div>} 
            </div>
        );
    }
}
const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(ProfileVerified);